<div class="message">
  @if (message().createdAt && showTimestamp()) {
    <time class="timestamp" [attr.datetime]="message().createdAt">{{ formattedCreatedAt() }}</time>
  }
  @if (message().attachments?.length) {
    <div class="attachments" aria-label="Message attachments">
      @for (file of message().attachments; track file.id) {
        <app-chat-attachment-tile [file]="file" />
      }
    </div>
  }
  @if (message().text) {
    <div class="bubble">
      <div class="text">{{ message().text }}</div>
    </div>
  }
  @if (message().text) {
    <div class="actions">
      <button
        cuiButton
        square
        size="small"
        variant="plain"
        type="button"
        (click)="onCopy()"
        matTooltip="Copy"
        aria-label="Copy message">
        <span class="material-symbols-outlined" aria-hidden="true">content_copy</span>
      </button>
    </div>
  }
</div>
